import { createContext, useCallback, useEffect, useState, useMemo } from "react"
import LocalStorage from "../services/LocalStorage"


const PreferredViewContext = createContext()
export default PreferredViewContext

// keep these the same as the corresponding translation keys
const PREFERRED_VIEW_TYPES = {
    'performance': 'performance',
    'greenkeeping': 'greenkeeping',
}

export function PreferredViewContextProvider({ ...props }) {

    const [preferredView, setPreferredView] = useState(getInitState())

    useEffect(() => {
        LocalStorage.setItem('preferred-view-type', preferredView)
    }, [preferredView])

    const handlePreferredViewChange = useCallback(() => {
        setPreferredView(curr => curr === PREFERRED_VIEW_TYPES.performance ?
            PREFERRED_VIEW_TYPES.greenkeeping
            : PREFERRED_VIEW_TYPES.performance
        )
    }, [])

    const isPerformanceMode = useMemo(() => {
        return preferredView === PREFERRED_VIEW_TYPES.performance
    }, [preferredView])

    return <PreferredViewContext.Provider
        value={{
            isPerformanceMode,
            preferredView,
            setPreferredView,
            PREFERRED_VIEW_TYPES,
            handlePreferredViewChange,
        }}
        {...props}
    />
}

function getInitState() {
    const localData = LocalStorage.getItem('preferred-view-type')
    if (Object.keys(PREFERRED_VIEW_TYPES).includes(localData)) {
        return localData
    } else {
        return PREFERRED_VIEW_TYPES.greenkeeping
    }
}